require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-david-lindahl-investigator-turned-front-end-engineer-and-founder.json") })
        }
      }, "path---blog-meet-david-lindahl-investigator-turned-front-end-engineer-and-founder");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-david-lindahl-investigator-turned-front-end-engineer-and-founder!./.cache/json/blog-meet-david-lindahl-investigator-turned-front-end-engineer-and-founder.json
// module id = 948
// module chunks = 231608221292675